export const mixins = {
  methods: {
    handleInputHeight(e) {
      // Dynamically set the height of textarea
      // Conditional below checks that the input has a value and only
      // adjusts the height of the input if the scrollHeight in pixels is
      // greater than the default single-line height of 20px + vertical padding
      if (e.currentTarget.value && e.target.scrollHeight > 22) {
        e.target.style.height = (e.target.scrollHeight) + 'px';
      } else {
        e.target.style.height = '20px';
      }
    },
  },
};

/**
 * When the component is mounted, registers a click listener for any clicks within the menu or its children.
 * Cleans up the click listener when the component is unmounted.
 * @param {string} callbackName The name of the method within this component's `methods` to be called with click events.
 * @return {object}
 */
export const useMenuClickListener = (callbackName) => {
  const listenerName = Symbol(`Menu click listener for ${this?.$options?.name ?? 'child component'}`);
  return {
    inject: {
      addMenuClickListener: {
        from: 'addMenuClickListener',
        default: () => () => {}, // no-op
      },
      removeMenuClickListener: {
        from: 'removeMenuClickListener',
        default: () => () => {}, // no-op
      },
    },
    mounted() {
      this.addMenuClickListener(listenerName, this[callbackName]);
    },
    beforeUnmount() {
      this.removeMenuClickListener(listenerName, this[callbackName]);
    },
  };
};
